import { evm } from '@shapeshiftoss/chain-adapters';
const SAFE_GAS_LIMIT = '100000';
export const getEvmTxFees = async (args) => {
    const { adapter, supportsEIP1559 } = args;
    const { average } = await adapter.getGasFeeData();
    return evm.calcNetworkFeeCryptoBaseUnit({
        ...average,
        supportsEIP1559,
        gasLimit: SAFE_GAS_LIMIT,
    });
};
